module.exports = __webpack_public_path__ + "a2314fc9/img/upload-icon.9179ae4e.svg";